// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "metaScore.Player.umd.min." + ({"282":"blockly-locale-en","335":"blockly-locale-fr"}[chunkId] || chunkId) + ".js";
};